<div fxLayout.gt-md="row" fxLayout="column" fxLayoutAlign="space-between stretch">

  <mat-card fxFlex="100">
    <mat-card-content>
      <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
             fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>
            Furnishings |
            <span *ngIf="isNewFurnishingFeed" class="text-warning ifc-link" (click)="toggleNewFurnishingSettings()"
                  matBadgeColor="warn" [matBadge]="filteredFurnishingSettings.length" matBadgeOverlap="false">
              Show Existing
            </span>
            <span *ngIf="!isNewFurnishingFeed" class="text-success ifc-link" (click)="toggleNewFurnishingSettings()"
                  matBadgeColor="accent" [matBadge]="filteredNewFurnishingSettings.length" matBadgeOverlap="false">
              Show New
            </span>
          </label>

          <button type="button" class="add-action-button" mat-flat-button color="accent" (click)="saveFurnishingSettings()"
                  [disabled]="!isFurnishingSettingsDirty || loading">
            <mat-icon>done</mat-icon> Save
          </button>
        </div>

        <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          
          <div class="w-50">
            <mat-form-field>
              <input matInput type="text" placeholder="Filter by Release" matInput [formControl]="releaseControl" [matAutocomplete]="releaseAuto">
              <button mat-button *ngIf="releaseControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearRelease()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #releaseAuto="matAutocomplete" [displayWith]="displayReleaseName" (optionSelected)="onReleaseSelected($event)">
                <mat-option *ngFor="let release of filteredReleases | async" [value]="release">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                      <span [innerHtml]="release.name | highlight: releaseControl.value"></span>
                    </div>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <button *ngIf="!showOnlyDeprecated" type="button" mat-flat-button (click)="onShowOnlyDeprecated()" matTooltip="Show only deprecated furnishing names.">
            Show Only Deprecated
          </button>
          <button *ngIf="showOnlyDeprecated" type="button" mat-flat-button (click)="onShowOnlyDeprecated()">
            Clear Filter
          </button>

        </div>

        <ng-container *ngIf="isNewFurnishingFeed">
          <mat-card *ngFor="let furnishingSetting of pagedNewFurnishingSettings" class="contrast">
            <mat-card-content fxLayout="column" fxLayoutGap="20px">
              <div fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                <mat-form-field>
                  <mat-label>Furnishing Name</mat-label>
                  <input type="text" matInput placeholder="Furnishing Name" [(ngModel)]="furnishingSetting.furnishingName" readonly>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Click To Build Furnishing Tag</mat-label>
                  <input type="text" matInput placeholder="" [(ngModel)]="furnishingSetting.furnishingTag" (click)="expandForEdit(furnishingSetting, true)" readonly>
                  <button *ngIf="!furnishingSetting.editing" mat-icon-button matSuffix tabindex="-1" aria-label="Edit Furnishing Tag" (click)="expandForEdit(furnishingSetting, true)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button *ngIf="furnishingSetting.editing" mat-icon-button matSuffix tabindex="-1" aria-label="Clear Furnishing Tag" (click)="clearFurnishingSettings(furnishingSetting)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
                <div *ngIf="showFlippedNotSetWarning(furnishingSetting)">
                  <mat-icon class="warning" matTooltip="The furnishing name contains facing flipped or hand flipped, but has not been set as such in the advanced settings.">warning_amber</mat-icon>
                </div>
              </div>
              <div *ngIf="furnishingSetting.editing">
                <div *ngIf="!furnishingSetting.toBeRemoved && !furnishingSetting.doNotReplace" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <mat-form-field>
                    <mat-label>Classification</mat-label>
                    <mat-select [(ngModel)]="furnishingSetting.productClassificationId" #furnishingTagType="ngModel" (selectionChange)="onClassificationChange(furnishingSetting)" [disabled]="!productClassifications || productClassifications.length === 0" required>
                      <mat-option *ngFor="let item of productClassifications" [value]="item.id">
                        {{ item.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="furnishingTagType.errors?.['required']">
                      Classification is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="furnishingSetting.productTypeId" #furnishingTagType="ngModel" (selectionChange)="onTypeChange(furnishingSetting)" [disabled]="!furnishingSetting.productClassificationId || !productTypes || productTypes.length === 0" required>
                      <mat-option *ngFor="let item of filterTypesByClassification(furnishingSetting)" [value]="item.id">
                        {{ item.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="furnishingTagType.errors?.['required']">
                      Type is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div *ngIf="furnishingSetting.productTypeId && !furnishingSetting.toBeRemoved && !furnishingSetting.doNotReplace" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <product-specification-tree
                  [productSpecifications]="productSpecifications"
                  [productTypeIdFilter]="furnishingSetting.productTypeId"
                  [selectedProductSpecificationIds]="furnishingSetting.productSpecificationIds"
                  (onProductSpecificationSelectionChanged)="onProductSpecificationSelectionChanged($event, furnishingSetting)"
                  [readOnly]="false"
                  ></product-specification-tree>
                </div>
                <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center center">
                  <button mat-button class="advanced-option-toggle" *ngIf="!furnishingSetting.advancedOptionsOpened" (click)="furnishingSetting.advancedOptionsOpened = true">Show Advanced Options</button>
                  <button mat-button class="advanced-option-toggle" *ngIf="furnishingSetting.advancedOptionsOpened" (click)="furnishingSetting.advancedOptionsOpened = false">Hide Advanced Options</button>
                </div>
                <div *ngIf="furnishingSetting.productTypeId && furnishingSetting.advancedOptionsOpened && !furnishingSetting.toBeRemoved && !furnishingSetting.doNotReplace" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <mat-form-field>
                    <mat-label>Number</mat-label>
                    <mat-select [(ngModel)]="furnishingSetting.productNumber" #furnishingTagType="ngModel" (selectionChange)="updateTag(furnishingSetting)">
                      <mat-option *ngFor="let item of productNumbers" [value]="item">
                        {{ item }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-checkbox [(ngModel)]="furnishingSetting.productFacingFlipped" #furnishingTagType="ngModel" (change)="updateTag(furnishingSetting)">Facing Flipped</mat-checkbox>
                  <mat-checkbox [(ngModel)]="furnishingSetting.productHandednessFlipped" #furnishingTagType="ngModel" (change)="updateTag(furnishingSetting)">Handedness Flipped</mat-checkbox>
                </div>
                <div *ngIf="furnishingSetting.advancedOptionsOpened" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <mat-checkbox [(ngModel)]="furnishingSetting.toBeRemoved" #furnishingTagType="ngModel" (change)="onToBeRemovedSelected(furnishingSetting)">To Be Removed </mat-checkbox>
                  <mat-checkbox [(ngModel)]="furnishingSetting.doNotReplace" #furnishingTagType="ngModel" (change)="onDoNotReplaceSelected(furnishingSetting)">Do Not Replace</mat-checkbox>
                </div>
                <div *ngIf="furnishingSetting.productTypeId" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="end center">
                  <button type="button" mat-flat-button color="accent" aria-label="Complete Editing Furnishing Tag" class="complete-edit-button" (click)="expandForEdit(furnishingSetting, false)">
                    Complete
                  </button>
                </div>
              </div>
              
            </mat-card-content>
          </mat-card>

          <div *ngIf="filteredNewFurnishingSettings.length === 0 && !loading">
            No new furnishings to configure, perfect!
          </div>

          <div *ngIf="newFurnishingSettings.length === 0 && loading">
            Loading furnishing settings...
          </div>

          <mat-paginator *ngIf="filteredNewFurnishingSettings.length" (page)="onNewFurnishingsPageChange($event)"
                         [pageIndex]="newFurnishingSettingsPageIndex" [length]="filteredNewFurnishingSettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>

        <ng-container *ngIf="!isNewFurnishingFeed">
          <mat-card *ngFor="let furnishingSetting of pagedFurnishingSettings" class="contrast">
            <mat-card-content fxLayout="column" fxLayoutGap="20px">
              <div fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                <mat-form-field>
                  <mat-label>Furnishing Name</mat-label>
                  <input type="text" matInput placeholder="Furnishing Name" [(ngModel)]="furnishingSetting.furnishingName" readonly>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Furnishing Tag </mat-label>
                  <input type="text" matInput placeholder="" [(ngModel)]="furnishingSetting.furnishingTag" (click)="expandForEdit(furnishingSetting, true)" readonly>
                  <button *ngIf="!furnishingSetting.editing" mat-icon-button matSuffix tabindex="-1" aria-label="Edit Furnishing Tag" (click)="expandForEdit(furnishingSetting, true)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button *ngIf="furnishingSetting.editing" mat-icon-button matSuffix tabindex="-1" aria-label="Clear Furnishing Tag" (click)="clearFurnishingSettings(furnishingSetting)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
                <button mat-icon-button color="accent" aria-label="Remove" (click)="removeFurnishingSetting(furnishingSetting)">
                  <mat-icon>delete</mat-icon>
                </button>
                <div *ngIf="showFlippedNotSetWarning(furnishingSetting)">
                  <mat-icon class="warning" matTooltip="The furnishing name contains facing flipped or hand flipped, but has not been set as such in the advanced settings.">warning_amber</mat-icon>
                </div>
                <div *ngIf="showMissingProductTypeWarning(furnishingSetting)">
                  <mat-icon class="warning" matTooltip="The furnishing does not have a product type set.">warning_amber</mat-icon>
                </div>
              </div>
              <div *ngIf="furnishingSetting.editing">
                <div *ngIf="!furnishingSetting.toBeRemoved && !furnishingSetting.doNotReplace" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <mat-form-field>
                    <mat-label>Classification</mat-label>
                    <mat-select [(ngModel)]="furnishingSetting.productClassificationId" #furnishingTagType="ngModel" (selectionChange)="onClassificationChange(furnishingSetting)" [disabled]="!productClassifications || productClassifications.length === 0" required>
                      <mat-option *ngFor="let item of productClassifications" [value]="item.id">
                        {{ item.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="furnishingTagType.errors?.['required']">
                      Classification is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="furnishingSetting.productTypeId" #furnishingTagType="ngModel" (selectionChange)="onTypeChange(furnishingSetting)" [disabled]="!furnishingSetting.productClassificationId || !productTypes || productTypes.length === 0" required>
                      <mat-option *ngFor="let item of filterTypesByClassification(furnishingSetting)" [value]="item.id">
                        {{ item.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="furnishingTagType.errors?.['required']">
                      Type is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div *ngIf="furnishingSetting.productTypeId && !furnishingSetting.toBeRemoved && !furnishingSetting.doNotReplace" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <product-specification-tree
                  [productSpecifications]="productSpecifications"
                  [productTypeIdFilter]="furnishingSetting.productTypeId"
                  [selectedProductSpecificationIds]="furnishingSetting.productSpecificationIds"
                  (onProductSpecificationSelectionChanged)="onProductSpecificationSelectionChanged($event, furnishingSetting)"
                  [readOnly]="false"
                  ></product-specification-tree>
                </div>
                <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center center">
                  <button mat-button class="advanced-option-toggle" *ngIf="!furnishingSetting.advancedOptionsOpened" (click)="furnishingSetting.advancedOptionsOpened = true">Show Advanced Options</button>
                  <button mat-button class="advanced-option-toggle" *ngIf="furnishingSetting.advancedOptionsOpened" (click)="furnishingSetting.advancedOptionsOpened = false">Hide Advanced Options</button>
                </div>
                <div *ngIf="furnishingSetting.productTypeId && furnishingSetting.advancedOptionsOpened && !furnishingSetting.toBeRemoved && !furnishingSetting.doNotReplace" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <mat-form-field>
                    <mat-label>Number</mat-label>
                    <mat-select [(ngModel)]="furnishingSetting.productNumber" #furnishingTagType="ngModel" (selectionChange)="updateTag(furnishingSetting)">
                      <mat-option *ngFor="let item of productNumbers" [value]="item">
                        {{ item }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-checkbox [(ngModel)]="furnishingSetting.productFacingFlipped" #furnishingTagType="ngModel" (change)="updateTag(furnishingSetting)">Facing Flipped</mat-checkbox>
                  <mat-checkbox [(ngModel)]="furnishingSetting.productHandednessFlipped" #furnishingTagType="ngModel" (change)="updateTag(furnishingSetting)">Handedness Flipped</mat-checkbox>
                </div>
                <div *ngIf="furnishingSetting.advancedOptionsOpened" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
                  <mat-checkbox [(ngModel)]="furnishingSetting.toBeRemoved" #furnishingTagType="ngModel" (change)="onToBeRemovedSelected(furnishingSetting)">To Be Removed </mat-checkbox>
                  <mat-checkbox [(ngModel)]="furnishingSetting.doNotReplace" #furnishingTagType="ngModel" (change)="onDoNotReplaceSelected(furnishingSetting)">Do Not Replace</mat-checkbox>
                </div>
                <div *ngIf="furnishingSetting.productTypeId" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="end center">
                  <button type="button" mat-flat-button color="accent" aria-label="Complete Editing Furnishing Tag" class="complete-edit-button" (click)="expandForEdit(furnishingSetting, false)">
                    Complete
                  </button>
                </div>
              </div>
              
            </mat-card-content>
          </mat-card>

          <div *ngIf="filteredFurnishingSettings.length === 0 && !loading">
            No furnishings have been configured.
          </div>

          <div *ngIf="furnishingSettings.length === 0 && loading">
            Loading furnishing settings...
          </div>

          <mat-paginator *ngIf="filteredFurnishingSettings.length" (page)="onFurnishingsPageChange($event)"
                         [pageIndex]="furnishingSettingsPageIndex" [length]="filteredFurnishingSettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card ngStyle.gt-md="max-width: 450px;">
    <mat-card-content>
      <h2>Documentation</h2>

      <p>This configuration maps furnishings that are defined in CAD to a concise set of furnishings categories that is then used to furnish a house.</p>
      <h3>How are Furnishings Used</h3>
      <p>Furnishings are used to replace furnishings that are defined in CAD with high quality furnishings based on the theme that is selected.</p>
      <p>A House that does not have a specific furnishing type defined in the CAD will fall back to using the automated furniture placement rules. For example if rugs have not been placed in the CAD file, they will be placed automatically instead.</p>
      <h3>Building a Furnishing Tag</h3>
      <p>Select a furnishing options that most closely matches the furnishing type.</p>
      <p>Some furnishings can have multiple details that are important when theming. For example <code>Bedside Table</code>, <code>Bedside Table Left</code> and <code>Bedside Table Right</code>. Try to build the the type that most closely matches the Furnishing Name. In the case of a furnishing named 'Side Table', using <code>Furniture</code> → <code>Table</code> → <code>Bedside</code> would be the most suitable match.</p>
      <h4>Advanced Options</h4>
      <p><code>Number</code> will append the selected number to the end of the tag. This can be used to differentiate between two furnishings that would otherwise have identical tags.</p>
      <p><code>Facing Flipped</code> and <code>Handedness Flipped</code> will be appended to the tag when selected. This then allows for differentiation between identical furnishings where the model has been flipped in CAD.</p>
      <br />
      <p><code>To Be Removed</code> will remove the furnishing that has been defined in CAD. This then allows for the automated furniture placement to be used if required.</p>
      <p><code>Do Not Replace</code> will leave the original CAD model intact. This is useful for when you do not want that item to be replaced by a high quality model or if there is no suitable furnishing type to choose from.</p>
    </mat-card-content>
  </mat-card>

</div>
